import { render, staticRenderFns } from "./edit-role-dialog.vue?vue&type=template&id=1736b57d&"
import script from "./edit-role-dialog.vue?vue&type=script&lang=js&"
export * from "./edit-role-dialog.vue?vue&type=script&lang=js&"
import style0 from "./edit-role-dialog.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1736b57d')) {
      api.createRecord('1736b57d', component.options)
    } else {
      api.reload('1736b57d', component.options)
    }
    module.hot.accept("./edit-role-dialog.vue?vue&type=template&id=1736b57d&", function () {
      api.rerender('1736b57d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/roles/components/edit-role-dialog.vue"
export default component.exports